import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { AppStrings } from "../../utils/constants/AppStrings";
import { getApiErrorMessage } from "../../utils/ErrorUtils";
import { bonusAdminEnvelope } from "./bonusAdminBody";
import { getCampaignQueryKey } from "./useGetCampaign";
import { LIST_CAMPAIGNS_QUERY_KEY } from "./useListCampaigns";

type StoredToken = { AccessToken?: string };

async function deleteCampaign(campaignId: string): Promise<string | undefined> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.DELETE_DYNAMIC_BONUS_CAMPAIGN.replace(
    "{campaign_id}",
    campaignId,
  );
  const response = await instance.delete(url);
  return bonusAdminEnvelope(response).message;
}

export const useDeleteCampaign = (campaignId: string) => {
  const queryClient = useQueryClient();

  return useMutation<string | undefined, Error, void>({
    mutationFn: () => deleteCampaign(campaignId),
    onSuccess: (backendMessage) => {
      queryClient.invalidateQueries({ queryKey: LIST_CAMPAIGNS_QUERY_KEY });
      queryClient.removeQueries({ queryKey: getCampaignQueryKey(campaignId) });
      message.success(
        backendMessage || AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED,
      );
    },
    onError: (error) => {
      message.error(
        getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED),
      );
    },
  });
};
